import { render, staticRenderFns } from "./OnlineSpecificationProgramPicker.vue?vue&type=template&id=5836323f&scoped=true&"
import script from "./OnlineSpecificationProgramPicker.vue?vue&type=script&lang=js&"
export * from "./OnlineSpecificationProgramPicker.vue?vue&type=script&lang=js&"
import style0 from "./OnlineSpecificationProgramPicker.vue?vue&type=style&index=0&id=5836323f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836323f",
  null
  
)

export default component.exports